import { MetadataEntityData } from '../model/metadata.entity.data';
import { MetadataEntityFieldData } from '../model/metadata.entity.field.data';
import 'reflect-metadata';
import { MetadataCatalog } from '../metadata.catalog';


export function getMetadata(target: any): MetadataEntityData {

    const fields = target.__meta_fields__ as MetadataEntityFieldData[];
    const data = target.__meta__ as MetadataEntityData;

    const meta = { ...data, fields };

    MetadataCatalog.registerEntity(meta);

    return meta;

}


